import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, verifySession, getSubscriptionTypesPublic } from "../services/authService";
import StripePaymentModal from "../components/StripePaymentModal";

const PRO_PLAN = {
	monthly: { idAbonnementType: 4, prix: 19.99, period: "/mois" },
	yearly: { idAbonnementType: 6, prix: 199.99, period: "/an", monthlyEquivalent: "16.67" },
};

const FALLBACK_PRO_FEATURES = [
	"Entraînements illimités",
	"Synchronisation cloud",
	"Templates personnalisés",
	"Dashboard mobile",
	"Planification avancée",
	"Dashboard Coach web",
	"Jusqu'à 100 élèves",
];

function ProUpgrade() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [billingPeriod, setBillingPeriod] = useState("monthly");
	const [showPayment, setShowPayment] = useState(false);
	const [selectedPlan, setSelectedPlan] = useState(null);
	const [proFeatures, setProFeatures] = useState(FALLBACK_PRO_FEATURES);

	useEffect(() => {
		const checkSession = async () => {
			if (!isLoggedIn()) {
				navigate("/login");
				return;
			}
			const isValid = await verifySession();
			if (!isValid) {
				navigate("/login");
				return;
			}
			// Fetch dynamic features
			const result = await getSubscriptionTypesPublic();
			if (result.success) {
				const proPlan = result.types.find(t => t.libelle?.toLowerCase().includes("pro") && t.fonctionnalites?.length > 0);
				if (proPlan) {
					setProFeatures(proPlan.fonctionnalites.map(f => f.libelle));
				}
			}
			setLoading(false);
		};
		checkSession();
	}, [navigate]);

	const handleSubscribe = () => {
		const plan = PRO_PLAN[billingPeriod];
		setSelectedPlan({
			idAbonnementType: plan.idAbonnementType,
			libelle: "Pro",
			prix: plan.prix,
			billingPeriod,
		});
		setShowPayment(true);
	};

	const handlePaymentSuccess = () => {
		setShowPayment(false);
		navigate("/coach");
	};

	if (loading) {
		return (
			<div className="page">
				<div className="pro-upgrade-container">
					<p style={{ color: "#b0b0b0", textAlign: "center" }}>Chargement...</p>
				</div>
			</div>
		);
	}

	return (
		<div className="page">
			<div className="pro-upgrade-container">
				<div className="orange-banner" style={{ maxWidth: "500px", minHeight: "auto" }}>
					<h2 className="orange-title" style={{ fontSize: "36px" }}>
						👑 GymNote Pro
					</h2>
					<p style={{ color: "rgba(255,255,255,0.6)", marginTop: "-8px", marginBottom: "24px", fontSize: "15px" }}>
						Debloquez le Dashboard Coach et gerez vos eleves depuis le web
					</p>

					<div className="billing-toggle billing-toggle-home">
						<span className={billingPeriod === "monthly" ? "active" : ""}>Mensuel</span>
						<label className="toggle-switch">
							<input
								type="checkbox"
								checked={billingPeriod === "yearly"}
								onChange={() => setBillingPeriod(billingPeriod === "monthly" ? "yearly" : "monthly")}
							/>
							<span className="toggle-slider"></span>
						</label>
						<span className={billingPeriod === "yearly" ? "active" : ""}>
							Annuel <span className="billing-savings">-17%</span>
						</span>
					</div>

					<div className="pricing-card pricing-card-featured" style={{ width: "100%", maxWidth: "380px" }}>
						<p className="pricing-name">Pro</p>
						<p className="pricing-price">
							{PRO_PLAN[billingPeriod].prix}€<span>{PRO_PLAN[billingPeriod].period}</span>
						</p>
						{billingPeriod === "yearly" && (
							<p className="pricing-equivalent">
								soit {PRO_PLAN.yearly.monthlyEquivalent}€/mois
							</p>
						)}

						<ul className="pricing-features">
							{proFeatures.map((feature, index) => (
								<li key={index}>{feature}</li>
							))}
						</ul>

						<button className="pricing-cta-button" onClick={handleSubscribe}>
							S'abonner a Pro
						</button>
					</div>

					<button
						className="pro-upgrade-back"
						onClick={() => navigate(-1)}
					>
						Retour
					</button>
				</div>
			</div>

			{showPayment && selectedPlan && (
				<StripePaymentModal
					plan={selectedPlan}
					onClose={() => setShowPayment(false)}
					onSuccess={handlePaymentSuccess}
				/>
			)}
		</div>
	);
}

export default ProUpgrade;
